export default "__VITE_ASSET__e0b6a808__"